/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { PureComponent } from 'react';
import Fragment from 'react-dot-fragment';
import BannerLayout from "../../../layouts/banner";
import { getRequest } from '../../../../../api/ApiService';
import { Loader } from 'react-loaders';
import Auth from '../../../../../routes/Auth';

import Image from '../../../../../containers/assets/pf19.png';

class GrossMarginsStep3 extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      loaded: false,
      grossMargin: 0,
    };
  }

  componentDidMount() {
    const { activeRound } = this.props;

    getRequest(
      `${process.env.REACT_APP_API_URL}v2/games/targets/?course=${Auth.getCourseId()}`,
    )
      .then(res => {
        const targets = res.body.find(i => i.round_number === activeRound);

        this.setState({
          loaded: true,
          grossMargin: Number(targets.gross_margin || 0),
        })
      })
      .catch(err => {});
  }

  render() {
    const { loaded, grossMargin } = this.state;

    return loaded ? (
      <BannerLayout
        section="FEEDBACK"
        subSection="GROSS MARGINS"
        hideAlert={true}
        subTitle="Unit Economics"
        paragraph1={(
          <Fragment>
            Gross margins is an unit economic measurement that informs managers on how much profit they are
            generating on each unit of sale. Some companies have very impressive gross margins and some have
            very low gross margins yet still very successful.
          </Fragment>
        )}
        paragraph2={(
          <Fragment>
            In the exercise, however, your team had to hit a gross margin target of <b>{Number((grossMargin * 100).toFixed(2))}%</b>.
          </Fragment>
        )}
        visual={(
          <img src={Image} alt="preview" />
        )}
        visualProps={{
          noBorder: true,
          noBackground: true,
        }}
      />
    ) : <Loader type="ball-scale-ripple" active />;
  }

}

export default GrossMarginsStep3;



// WEBPACK FOOTER //
// ./src/components/performance-feedback/pages/feedback/gross-margins/step3.js